import MuiTextField from '@mui/material/TextField';
import { styled } from '@mui/system';
import colors from '../../assets/colors';

const TextField = styled(MuiTextField, {
  shouldForwardProp: (prop) =>
    prop !== 'bordered' && prop !== 'modal' && prop !== 'login',
})(({ bordered, modal, login }) => ({
  ...((bordered || modal) && {
    borderRadius: '4px',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: `1.5px solid ${colors.agroweGreen}`,
      },
      '&:hover fieldset': {
        opacity: 0.6,
        border: `1.5px solid ${colors.agroweGreen}`,
      },
      '&.Mui-focused fieldset': {
        border: `1.5px solid ${colors.agroweGreen}`,
      },
    },
  }),
  ...(modal && {
    marginRight: 25,
    marginBottom: 20,
    minWidth: 275,
  }),
  ...(login && {
    borderRadius: '4px',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: `1px solid ${colors.agroweGreen}`,
      },
      '&:hover fieldset': {
        opacity: 0.6,
        border: `1px solid ${colors.agroweGreen}`,
      },
      '&.Mui-focused fieldset': {
        border: `1px solid ${colors.agroweGreen}`,
      },
    },
  }),
  ...(!bordered &&
    !modal &&
    !login && {
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: colors.oldAgroweGreen,
        },
        '&:hover fieldset': {
          opacity: 0.6,
          borderColor: colors.oldAgroweGreen,
        },
        '&.Mui-focused fieldset': {
          borderColor: colors.oldAgroweGreen,
        },
      },
    }),
  '& label.Mui-focused': {
    color: colors.oldAgroweGreen,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: colors.oldAgroweGreen,
  },
}));

export default TextField;
